import { MutableRefObject } from 'react';
// From https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/setRef.js
export default function setRef<T>(
  ref: ((instance: T | null) => void) | MutableRefObject<T> | null,
  value: T
): void {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref !== null && 'current' in ref) {
    ref.current = value;
  }
}
